import * as Yup from 'yup';

import type { PhysicalDockNumberRange } from '../../contracts/PhysicalDocks';

export const physicalDockRangeConflictMessage = (buildingName: string) =>
  `Já existem Docas cadastradas no Prédio: ${buildingName} neste intervalo!`;

const MAX_PHYSICAL_DOCKS_PER_BATCH = 500;
export const MAX_PHYSICAL_DOCK_NUMBER = 4_294_967_295;
const MAX_PHYSICAL_DOCKS_MESSAGE =
  'É possível criar no máximo 500 docas por vez.';

export const hasPhysicalDockRangeConflict = (
  ranges: PhysicalDockNumberRange[],
  startNumber: number,
  endNumber: number
): boolean =>
  ranges.some((range) => startNumber <= range.end && endNumber >= range.start);

export class CreatePhysicalDocksBulkValidator {
  public get schema() {
    return Yup.object()
      .shape({
        warehouseId: Yup.number()
          .typeError('Informe o id do armazém')
          .integer('Informe um id de armazém válido')
          .positive('Informe um id de armazém válido')
          .required('Informe o id do armazém'),
        buildingId: Yup.number()
          .typeError('Informe o prédio')
          .integer('Informe um prédio válido')
          .positive('Informe um prédio válido')
          .required('Informe o prédio'),
        baseName: Yup.string().trim().required('Informe o nome base das docas'),
        startNumber: Yup.number()
          .typeError('Informe o número inicial')
          .integer('Informe um número inicial inteiro')
          .test(
            'safe-integer',
            'Informe um número inicial inteiro seguro',
            (value) => value === undefined || Number.isSafeInteger(value)
          )
          .positive('Informe um número inicial positivo')
          .max(
            MAX_PHYSICAL_DOCK_NUMBER,
            `O número inicial deve ser menor ou igual a ${MAX_PHYSICAL_DOCK_NUMBER}`
          )
          .required('Informe o número inicial'),
        endNumber: Yup.number()
          .typeError('Informe o número final')
          .integer('Informe um número final inteiro')
          .test(
            'safe-integer',
            'Informe um número final inteiro seguro',
            (value) => value === undefined || Number.isSafeInteger(value)
          )
          .positive('Informe um número final positivo')
          .max(
            MAX_PHYSICAL_DOCK_NUMBER,
            `O número final deve ser menor ou igual a ${MAX_PHYSICAL_DOCK_NUMBER}`
          )
          .min(
            Yup.ref('startNumber'),
            'O número final deve ser maior ou igual ao inicial'
          )
          .required('Informe o número final')
          .test(
            'maximum-batch-size',
            MAX_PHYSICAL_DOCKS_MESSAGE,
            function (endNumber) {
              const { startNumber } = this.parent;

              if (
                typeof startNumber !== 'number' ||
                typeof endNumber !== 'number'
              ) {
                return true;
              }

              return (
                endNumber - startNumber + 1 <= MAX_PHYSICAL_DOCKS_PER_BATCH
              );
            }
          ),
        blocked: Yup.boolean().required('Informe se as docas estão bloqueadas'),
      })
      .noUnknown();
  }
}
